import React from 'react';
import { TrendingUp, Users, Globe } from 'lucide-react';
import testimonialVideo from './images/shakti_learn_testimonial.mp4';
import anjaliImage from './images/anjali_shaktilearn.jpeg';
import rekhaDeviImage from './images/RekhaDevi.jpeg';

export default function ImpactSection() {
  return (
    <div className="min-h-screen bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-center text-gray-900 mb-12">Our Impact</h1>

        {/* Key Metrics */}
        <div className="grid md:grid-cols-4 gap-8 mb-16">
          {[
            {number: "85%", label: "Improved English Skills"},
            {number: "3x", label: "Better Academic Performance"},
            {number: "50+", label: "School Partners"},
            {number: "3", label: "States Reached"}
          ].map((metric) => (
            <div key={metric.label} className="text-center">
              <div className="text-4xl font-bold text-purple-600">{metric.number}</div>
              <div className="text-gray-600 mt-2">{metric.label}</div>
            </div>
          ))}
        </div>

        {/* Success Stories */}
        <div className="mb-16">
          <h2 className="text-2xl font-semibold text-purple-600 mb-8">Success Stories</h2>
          <div className="grid md:grid-cols-2 gap-8">
            {[
              {
                name: "Anjali",
                location: "Community Manager",
                story: "After receiving education support from Shakti Learn, Anjali is now the head of a play school, inspiring young minds and creating educational opportunities for children in her community.",
                impact: "Now leads a play school and spreads hope as our community manager",
                image: anjaliImage
              },
              {
                name: "Rekha Devi",
                location: "Dairy Entrepreneur & Community Manager",
                story: "Started with basic literacy and math help from Shakti Learn, and now owns a successful small cattle farm selling dairy products. Both Anjali and Rekha Devi now spread hope and joy by being our community managers.",
                impact: "Owns a cattle farm and dairy business while serving as community manager",
                image: rekhaDeviImage
              }
            ].map((story) => (
              <div key={story.name} className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img src={story.image} alt={story.name} className="w-full h-64 object-contain" />
                <div className="p-6">
                  <h3 className="text-xl font-semibold mb-2">{story.name}</h3>
                  <p className="text-purple-600 mb-4">{story.location}</p>
                  <p className="text-gray-700 mb-4">{story.story}</p>
                  <div className="bg-purple-50 p-4 rounded-lg">
                    <p className="text-purple-700 font-semibold">{story.impact}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonial Video Section */}
        <div className="mb-16">
          <h2 className="text-2xl font-semibold text-purple-600 mb-8">Testimonial</h2>
          <div className="max-w-3xl mx-auto">
            <div className="aspect-w-16 aspect-h-9 rounded-lg overflow-hidden shadow-lg">
              <video 
                controls
                className="w-full h-full object-cover"
              >
                <source src={testimonialVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>

        {/* Impact Areas */}
        <div className="mb-16">
          <h2 className="text-2xl font-semibold text-purple-600 mb-8">How We Create Change</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: <TrendingUp className="h-8 w-8 text-purple-600" />,
                title: "Academic Excellence",
                description: "Our students see significant improvements in their English grades and overall academic performance."
              },
              {
                icon: <Users className="h-8 w-8 text-purple-600" />,
                title: "Community Impact",
                description: "Educated girls become role models in their communities, inspiring other students to pursue education."
              },
              {
                icon: <Globe className="h-8 w-8 text-purple-600" />,
                title: "Future Opportunities",
                description: "English proficiency opens doors to better educational opportunities and academic success."
              }
            ].map((area) => (
              <div key={area.title} className="bg-white rounded-lg shadow-lg p-6">
                <div className="w-12 h-12 rounded-md bg-purple-100 flex items-center justify-center mb-4">
                  {area.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{area.title}</h3>
                <p className="text-gray-600">{area.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="bg-purple-50 rounded-lg p-8 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Be Part of Our Story</h2>
          <p className="text-gray-600 mb-6">
            Join us in empowering more girls through education and academic development.
          </p>
          <button className="bg-purple-600 text-white px-8 py-3 rounded-md font-medium hover:bg-purple-700 transition-colors duration-200">
            Support Our Mission
          </button>
        </div>
      </div>
    </div>
  );
} 